// extracted by mini-css-extract-plugin
module.exports = {"footerLinks":"footer-links-module--footer-links--3U10k"};